import { TableUsers } from "../../components";

export const Users = () => {
  return (
    <div className="container__pages">
      <h2>Lista de usuarios</h2>
      <div className="container_form">
        <TableUsers />
      </div>
    </div>
  );
};
